// Hojas de Colonia nueva para el "Backup completo" de Reportes.
// Con el interruptor apagado devuelve {} y el backup sale igual que siempre.

import { fetchColoniaBackup, fetchFlags, fetchTanda2Backup } from "../../lib/coloniaApi.js";

export async function coloniaBackupSheets() {
  const flags = await fetchFlags();
  if (!flags.colonia) return {};
  const t2 = flags.tanda2 ? await tanda2Sheets() : {};

  const { inscripciones, cuotas, cobros, tarifas, beneficios, listas } = await fetchColoniaBackup();
  const nombre = (lista, id) => listas[lista].find((x) => x.id === id)?.nombre ?? "";
  const colegio = (id) => listas.colegios.find((c) => c.id === id)?.nombre ?? "";

  return {
    "Colonia chicos": inscripciones.map((i) => ({
      Inscripción: i.id,
      Temporada: i.season_id,
      Chico: i.chico?.nombre ?? "",
      Apellido: i.chico?.apellido ?? "",
      Edad: i.chico?.edad ?? "",
      Condición: i.chico?.condicion ?? "",
      Colegio: colegio(i.chico?.colegio_id),
      Canal: nombre("canales", i.chico?.canal_id),
      "Referido por": i.chico?.referido_por ?? "",
      Responsable: i.chico?.responsable?.nombre ?? "",
      WhatsApp: i.chico?.responsable?.whatsapp ?? "",
      Email: i.chico?.responsable?.email ?? "",
      Observaciones: i.chico?.observaciones ?? "",
      Estado: i.estado,
      "Motivo de baja": i.baja_motivo ?? "",
      "Inscripto el": i.enrolled_at,
      Total: i.amount_due,
      Cobrado: i.amount_paid,
    })),
    "Colonia modalidades": inscripciones.flatMap((i) =>
      (i.items ?? []).map((it) => ({
        Inscripción: i.id,
        Ítem: it.id,
        Mes: it.mes,
        Turno: nombre("turnos", it.turno_id),
        Plazo: nombre("plazos", it.plazo_id),
        Cantidad: it.cantidad,
        "Forma de pago": it.forma_pago,
        "Lista unitario": it.precio_lista_unit,
        "Desc. hermano": it.descuento_hermano,
        "Desc. manual": it.descuento_manual,
        Motivo: it.descuento_motivo ?? "",
        Autorizó: it.autorizado_por ?? "",
        "Piso forzado": it.piso_forzado_motivo ?? "",
        Final: it.precio_final,
      }))
    ),
    "Colonia cuotas": cuotas.map((q) => ({
      Cuota: q.id,
      Inscripción: q.enrollment_id,
      Ítem: q.item_id,
      Número: q.numero,
      Monto: q.monto,
      Vence: q.vence,
      Cobrado: q.cobrado,
      Estado: q.estado,
    })),
    "Colonia cobros": cobros.map((c) => ({
      Cobro: c.id,
      Cuota: c.cuota_id,
      Fecha: c.fecha,
      Monto: c.monto,
      Medio: c.medio,
      Cuenta: nombre("cuentas", c.cuenta_id),
      Nota: c.nota ?? "",
      Anulado: c.anulado ? "sí" : "",
      "Motivo anulación": c.motivo_anulacion ?? "",
    })),
    "Colonia tarifario": tarifas.map((t) => ({
      Temporada: t.season_id,
      Mes: t.mes,
      Condición: t.condicion,
      Turno: nombre("turnos", t.turno_id),
      Plazo: nombre("plazos", t.plazo_id),
      Efectivo: t.precio_efectivo ?? "",
      Cuotas: t.precio_cuotas ?? "",
      "Cant. cuotas": t.cant_cuotas ?? "",
      Piso: t.piso ?? "",
      Publicar: t.publicar ? "sí" : "no",
    })),
    "Colonia beneficios": beneficios.map((b) => ({
      Temporada: b.season_id,
      Mes: b.mes,
      Condición: b.condicion,
      Turno: nombre("turnos", b.turno_id),
      "Precio único": b.precio_unico,
      Vence: b.vence,
    })),
    ...t2,
  };
}

async function tanda2Sheets() {
  const { staffCategorias, staff, gastos, empresaCategorias, estructura } = await fetchTanda2Backup();
  const catStaff = (id) => staffCategorias.find((c) => c.id === id)?.nombre ?? "";
  const catEmp = (id) => empresaCategorias.find((c) => c.id === id)?.nombre ?? "";
  return {
    "Colonia equipo": staff.map((s) => ({
      Temporada: s.season_id,
      Nombre: s.nombre,
      Categoría: catStaff(s.categoria_id),
      Activo: s.activo ? "sí" : "no",
      Sueldos: Object.entries(s.montos ?? {}).map(([m, v]) => `${m}: ${v}`).join(" · "),
    })),
    "Colonia gastos": gastos.map((g) => ({
      Temporada: g.season_id,
      Mes: g.mes,
      Categoría: g.categoria,
      Concepto: g.concepto,
      Monto: g.monto,
      Tipo: g.tipo,
      Fecha: g.fecha ?? "",
      Anulado: g.anulado ? g.motivo_anulacion ?? "sí" : "",
    })),
    "Empresa estructura": estructura.map((e) => ({
      Concepto: e.concepto,
      Categoría: catEmp(e.categoria_id),
      "¿Para qué?": e.para === "producto" ? `producto ${e.para_producto_id}` : e.para,
      Mensual: e.monto_mensual,
      Desde: e.desde,
      Hasta: e.hasta ?? "",
      Serie: e.serie_id,
    })),
  };
}
